import React,{PropTypes} from "react";
import UsersDataTable from "../../../admin/users/UsersDataTable";
import { connect } from "react-redux";

class ClientUsersPage extends React.Component {
  render() {
    const {clientStatusType} =this.props;
    return (
      <div className="sub-content">
        <UsersDataTable key={clientStatusType} parent="ClientUsersPage" />
      </div>
    );
  }
}

ClientUsersPage.propTypes = {
  clientStatusType: PropTypes.string,
};

function mapStateToProps(state) {
  const clients = state.data.clients || {};
  return {
    clientStatusType: clients.active && clients.active.clientStatusType,
  };
}

export default connect(mapStateToProps)(ClientUsersPage);


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientUsers/ClientUsersPage.js